import { render, staticRenderFns } from "./EvergreenInfoPopUp.vue?vue&type=template&id=128ca535&scoped=true&"
import script from "./EvergreenInfoPopUp.vue?vue&type=script&lang=js&"
export * from "./EvergreenInfoPopUp.vue?vue&type=script&lang=js&"
import style0 from "./EvergreenInfoPopUp.vue?vue&type=style&index=0&id=128ca535&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128ca535",
  null
  
)

export default component.exports